var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2521 11.3043C8.2437 11.3406 8.2395 11.3841 8.2395 11.4348C8.2395 11.6087 8.31092 11.6957 8.45378 11.6957C8.52941 11.6957 8.61345 11.6739 8.70588 11.6304C8.79832 11.587 8.91597 11.5145 9.05882 11.413L9.22269 11.75C9.07983 11.9167 8.86555 12.0833 8.57983 12.25C8.30252 12.4167 7.96218 12.5 7.55882 12.5C7.23109 12.5 6.97479 12.4457 6.78992 12.337C6.60504 12.221 6.51261 12.0652 6.51261 11.8696L6.52521 11.7609C6.57563 11.3841 6.7479 10.2899 7.04202 8.47826L7.2437 7.21739L6.5 6.91304L6.58824 6.48913L8.7563 6.22826L9.05882 6.34783L8.2521 11.3043ZM8.39076 5.18478C8.16387 5.18478 7.96639 5.11232 7.79832 4.96739C7.63866 4.81522 7.55882 4.6413 7.55882 4.44565C7.55882 4.17754 7.65966 3.9529 7.86134 3.77174C8.07143 3.59058 8.33613 3.5 8.65546 3.5C8.91597 3.5 9.12185 3.57246 9.27311 3.71739C9.42437 3.85507 9.5 4.02174 9.5 4.21739C9.5 4.49275 9.40336 4.72464 9.21008 4.91304C9.01681 5.0942 8.7437 5.18478 8.39076 5.18478Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionTooltip);
export default __webpack_public_path__ + "static/media/accordion-tooltip.e0150f68.svg";
export { ForwardRef as ReactComponent };